import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import * as HistoricsReport from 'reports/components/historics';
import * as Common from 'common/components';
import HistoricReportsFiltersButton from './historics/HistoricsReportsFiltersButton';
import { Form } from 'common/components';
class HistoricsReportView extends Component {
  static propTypes = {
    company: PropTypes.object.isRequired,
    subcompany: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    children: PropTypes.arrayOf(PropTypes.element),
    filters: PropTypes.shape({
      fulltext: PropTypes.string.isRequired,
    }).isRequired,
    pagination: PropTypes.shape({
      page: PropTypes.number.isRequired,
      limit: PropTypes.number.isRequired,
      totalPages: PropTypes.number.isRequired,
      orderBy: PropTypes.string.isRequired,
      order: PropTypes.string.isRequired,
    }).isRequired,
    isLoading: PropTypes.bool.isRequired,
    handleToggleSearch: PropTypes.func.isRequired,
    handleExactSearch: PropTypes.func.isRequired,
    columnSearch: PropTypes.array.isRequired,
    handleFiltersChange: PropTypes.func.isRequired,
    handleFiltersSubmit: PropTypes.func.isRequired,
    handleLimitChange: PropTypes.func.isRequired,
    handleOrderChange: PropTypes.func.isRequired,
    handlePageChange: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = { isCollapsed: true };
    this.onPress = this.onPress.bind(this);
  }
  onPress(e) {
    e.preventDefault();
    this.setState({ isCollapsed: !this.state.isCollapsed });
  }

  render = () => (
    <Common.Wrapper fluid={true}>
      {/* <HistoricsReport.Header
        companyId={this.props.company.id}
        subcompanyId={this.props.subcompany.id}
        handleExport={this.props.handleExport}
        handleExportPDF={this.props.handleExportPDF}
      /> */}
      <div className="col-12">
        <Common.Portlet
          title={this.props.t('reports.title') + ' > ' + this.props.t('reports.historics.subtitle')}
          icon={'file-archive-o'}
          button={
            <div className="row">
              <Form.Button
                onClick={(e) => {
                  this.onPress(e);
                }}
                extraClassName="col-g btn btn-info ml-4 mr-4"
                text={`${
                  !this.state.isCollapsed
                    ? this.props.t('assets.fields.historics.buttonFilters.hideFilters')
                    : this.props.t('assets.fields.historics.buttonFilters.showFilters')
                }`}
              />
            </div>
          }
          buttonTwo={
            <div className="btn-group pull-right">
              <Common.Dropdown>
                <Common.DropdownElement onClick={this.props.handleExportXLSX}>
                  <i className="fa fa-table mr-1" />
                  {'  '}
                  {this.props.t('actions.exportXLSX')}
                </Common.DropdownElement>
                <Common.DropdownElement onClick={this.props.handleExport}>
                  <i className="fa fa-table mr-1" />
                  {'  '}
                  {this.props.t('actions.exportCSV')}
                </Common.DropdownElement>
                <Common.DropdownElement onClick={this.props.handleExportPDF}>
                  <i className="fa fa-archive mr-1" />
                  {'  '}
                  {this.props.t('actions.exportPDF')}
                </Common.DropdownElement>
              </Common.Dropdown>
            </div>
          }
        >
          {this.state.isCollapsed ? null : (
            <HistoricsReport.Filters
              handleToggleSearch={this.props.handleToggleSearch}
              handleExactSearch={this.props.handleExactSearch}
              columnSearch={this.props.columnSearch}
              accounts={this.props.accounts}
              employees={this.props.employees}
              costCenters={this.props.costCenters}
              status={this.props.status}
              values={this.props.filters}
              handleValueChange={this.props.handleFiltersChange}
              handleSubmit={this.props.handleFiltersSubmit}
            />
          )}

          <div className="mb-2" style={{ position: 'relative' }}>
            <HistoricsReport.Table
              company={this.props.company}
              subcompany={this.props.subcompany}
              permissions={this.props.permissions}
              count={this.props.count}
              orderBy={this.props.pagination.orderBy}
              order={this.props.pagination.order}
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.children}
            </HistoricsReport.Table>
            <Common.LoaderOverlay show={this.props.isLoading} />
          </div>
          <Common.Pagination
            {...this.props.pagination}
            customLimits={[25, 50, 100, 500]}
            handleLimitChange={this.props.handleLimitChange}
            handlePageChange={this.props.handlePageChange}
          />
        </Common.Portlet>
      </div>
    </Common.Wrapper>
  );
}

export default translate()(HistoricsReportView);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/components/HistoricsReportView.js